import { takeEvery } from "redux-saga/effects";
import { addNotification, markAsRead, clearNotifications, setNotificationsEnabled } from "../../../state/notification/notificationSlice";
import { saveNotificationsSaga } from "../saveNotifications/saveNotifications";

export function* watchNotificationChangesSaga() {
  yield takeEvery(addNotification.type, saveNotificationsSaga);
  yield takeEvery(markAsRead.type, saveNotificationsSaga);
  yield takeEvery(clearNotifications.type, saveNotificationsSaga);
  yield takeEvery(setNotificationsEnabled.type, saveNotificationsSaga);
}
